import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enCommon from "./locales/en/common.json";
import deCommon from "./locales/de/common.json";
import esCommon from "./locales/es/common.json";
import arCommon from "./locales/ar/common.json";
import nlCommon from "./locales/nl/common.json";
import ptCommon from "./locales/pt/common.json";
import ruCommon from "./locales/ru/common.json";
import ukCommon from "./locales/uk/common.json";
import hiCommon from "./locales/hi/common.json";
import urCommon from "./locales/ur/common.json";
import yoCommon from "./locales/yo/common.json";
import idCommon from "./locales/id/common.json";
import itCommon from "./locales/it/common.json";
import jaCommon from "./locales/ja/common.json";
import swCommon from "./locales/sw/common.json";
import plCommon from "./locales/pl/common.json";
import viCommon from "./locales/vi/common.json";
import roCommon from "./locales/ro/common.json";
import zhHantCommon from "./locales/zh-hant/common.json";
import zhCommon from "./locales/zh/common.json";
import hrCommon from "./locales/hr/common.json";
import faCommon from "./locales/fa/common.json";
import koCommon from "./locales/ko/common.json";
import svCommon from "./locales/sv/common.json";
import huCommon from "./locales/hu/common.json";
import sqCommon from "./locales/sq/common.json";
import frCommon from "./locales/fr/common.json";

const resources = {
  en: { common: enCommon },
  de: { common: deCommon },
  fr: { common: frCommon },
  es: { common: esCommon },
  ar: { common: arCommon },
  nl: { common: nlCommon },
  pt: { common: ptCommon },
  ru: { common: ruCommon },
  uk: { common: ukCommon },
  hi: { common: hiCommon },
  ur: { common: urCommon },
  yo: { common: yoCommon },
  id: { common: idCommon },
  it: { common: itCommon },
  ja: { common: jaCommon },
  sw: { common: swCommon },
  pl: { common: plCommon },
  vi: { common: viCommon },
  ro: { common: roCommon },
  "zh-hant": { common: zhHantCommon },
  zh: { common: zhCommon },
  hr: { common: hrCommon },
  fa: { common: faCommon },
  ko: { common: koCommon },
  sv: { common: svCommon },
  hu: { common: huCommon },
  sq: { common: sqCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    // Wait for initialization
    initImmediate: false,

    // Language detection options
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "i18nextLng",
    },

    interpolation: {
      escapeValue: false,
    },

    // Default namespace
    defaultNS: "common",
    ns: ["common"],

    // Key separator and nesting
    keySeparator: ".",
    nsSeparator: ":",
  })
  .then(() => {
    console.log("🌍 i18n initialized successfully");
    console.log("🌍 Current language:", i18n.language);
  })
  .catch((error) => {
    console.error("❌ i18n initialization failed:", error);
  });

export default i18n;
